import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDBzc-A4vtxgUphEk-U766H20GzIenuHNg",
  authDomain: "your-space-52763.firebaseapp.com",
  projectId: "your-space-52763",
  storageBucket: "your-space-52763.appspot.com",
  messagingSenderId: "711654293840",
  appId: "1:711654293840:web:d545b6c80b16c96454ec55",
  measurementId: "G-2SVKFXL4JG",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);
